var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userinfo
    ? _c("section", { staticClass: "mt-3" }, [
        _vm.userinfo
          ? _c(
              "div",
              [
                _c(
                  "b-overlay",
                  { attrs: { show: _vm.loading, rounded: "sm" } },
                  [
                    _c("h5", { staticClass: "mt-3" }, [
                      _vm._v(_vm._s(_vm.$t("FILTER.MESSAGE_STATUS.TITLE"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-1" },
                      [
                        _c("b-form-tags", {
                          attrs: {
                            "input-id": "tags-pills",
                            addButtonText: _vm.$t("ADD"),
                            "duplicate-tag-text": _vm.$t("DUPLICATE_TAG_TEXT"),
                            "invalid-tag-text": _vm.$t("INVALID_TAG_TEXT"),
                            "limit-tags-text": _vm.$t("LIMIT_TAGS_TEXT"),
                            "tag-variant": "secondary",
                            addButtonVariant: "secondary",
                            placeholder: _vm.$t("ADD"),
                            separator: ";",
                          },
                          model: {
                            value: _vm.messageStatus,
                            callback: function ($$v) {
                              _vm.messageStatus = $$v
                            },
                            expression: "messageStatus",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("hr", { staticClass: "p-0 m-0 mt-4 mb-2" }),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-fill mt-2",
                        attrs: { variant: "primary" },
                        on: { click: _vm.saveBtn },
                      },
                      [_vm._v(_vm._s(_vm.$t("SAVE")))]
                    ),
                    _vm.changed
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn-fill mt-2",
                            attrs: { variant: "secondary" },
                            on: { click: _vm.cancelBtn },
                          },
                          [_vm._v(_vm._s(_vm.$t("RESET")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }